module.exports = {
	"en": {
		"dot1": "Crosstab",
		"dot2": "Crosstab + Calendar",
		"dot3": "Calendar + Register",
		"pane_selector_button_1": "Crosstab",
		"pane_selector_button_2": "Calendar",
		"pane_selector_button_3": "Resgistry",
		"download": "Download in format"
	},
	"fr": {
		"dot1": "Tableau croisé",
		"dot2": "Tableau croisé + Calendrier",
		"dot3": "Calendrier + Registre",
		"pane_selector_button_1": "Tableau Croisé",
		"pane_selector_button_2": "Calendrier",
		"pane_selector_button_3": "Registre",
		"sum_receipts": "{agg} Livres est la somme des recettes {cols} {rows}",
		"performances_days": "{agg} est le nombre de représentations par jour {cols} {rows}",
		"mean_receipts_day": "{agg} Livres est la moyenne des recettes par jour {cols} {rows}",
		"mean_price": "{agg} Livres est la moyenne du prix des places {cols} {rows}",
		"currency": "Livres",
		"cancel": "Annuler",
		"ok": "OK",
		"calendar_tool_caption": "Changement d'outil",
		"calendar_tool_message": "Le passage de l'outil de comparaison à l'outil calendrier implique la reprise des sélections faites précédemment dans le premier outil. Tous les nouveaux choix de critères faits dans l'outil calendrier ne seront pas pris en compte.",
		"criteria_caption": "",
		"criteria_message": "Vous souhaitez générer un graphique avec une grande quantité de critères. Nous vous invitons à raffiner votre recherche pour une meilleure lisibilité.",
		"criteria_download_message": "Au besoin, vous pouvez télécharger directement le résultat de cette recherche.",
		"legend_caption": "Légende : {type}",
		"download": "Télécharger au format",
		"download-button": "Télécharger"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./i18n/app.json
// module id = 20
// module chunks = 0